import { render, staticRenderFns } from "./IconCaution.vue?vue&type=template&id=8fc458d0&"
import script from "./IconCaution.vue?vue&type=script&lang=js&"
export * from "./IconCaution.vue?vue&type=script&lang=js&"
import style0 from "./IconCaution.vue?vue&type=style&index=0&id=8fc458d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports